import { Box, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { CloseButton } from '@/components/form/baseInputs/Button/CloseButton';
import { Callout } from '@/components/notifications/Callout/Callout';
import { FONT_WEIGHTS } from '@/styles/tokens/fonts';

/**
 * Warns that this step creates entities rather than attaching to existing
 * ones — the distinction between it and the "Link data" step, and the reason
 * users end up with duplicates. Dismissible for the rest of the session.
 */
export function ImportWarningCallout({ message }: { message?: string }) {
  const [isDismissed, setIsDismissed] = useState(false);
  if (isDismissed) return null;

  return (
    <Callout severity="warning" skipTextWrapper sx={{ mb: 3 }}>
      <Stack direction="row" alignItems="center" spacing={2} width="100%">
        {/* `body-*` variants render as inline spans, so the heading and body
            need to be blocks to sit on separate lines. */}
        <Box flex={1}>
          <Typography
            component="div"
            variant="body-xs"
            fontWeight={FONT_WEIGHTS.bold}
          >
            Import warning
          </Typography>
          <Typography component="div" variant="body-xs">
            {message ??
              'Luminary will create new entities from any selected items on this step, which may result in duplicates.'}
          </Typography>
        </Box>
        <CloseButton
          size="xs"
          aria-label="Dismiss import warning"
          onClick={() => setIsDismissed(true)}
        />
      </Stack>
    </Callout>
  );
}
